import React from 'react'
import Image from 'gatsby-image'
import Link from 'gatsby-link'
import styled from 'styled-components'
import PlaqueInactive from '../assets/plaque.png'
import PlaqueActive from '../assets/plaque-active.png'
import DoorAnimation from './doorAnimation'

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;

  .button-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: middle;
    @media screen and (min-width: 767px) {
      padding-left: 3rem;
      padding-right: 3rem;
      padding-bottom: 100px;
    }
    @media screen and (max-width: 767px) {
      max-width: 150px;
      padding: 20px;
      font-size: 1rem;
    }
    @media screen and (max-width: 560px) {
      max-width: 100px;
      padding: 0px;
      font-size: 0.7rem;
    }
  }

  .image-container {
    max-width: 270px;
    width: 100%;
    @media screen and (max-width: 767px) {
      margin-bottom: -100px;
    }
    @media screen and (max-width: 494px) {
      margin-bottom: -60px;
      max-width: 140px;
    }
  }

  .door-button {
    .plaque {
      height: 100%;
      position: relative;
      img {
        height: 100% !important;
        filter: drop-shadow(5px 5px 0px rgba(0, 0, 0, 0.1));
      }
    }
    .text-wrapper {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: middle;
    }
  }
`

const PlaqueButton = ({ image, text, link }) => (
  <Link to={link}>
    <div className="plaque">
      <img src={image} alt="" />
      <div className="text-wrapper">
        <p className="has-text-white is-uppercase has-text-weight-bold">
          {text}
        </p>
      </div>
    </div>
  </Link>
)

const Open = ({ open }) => (
  <div>
    <Image sizes={open} />
  </div>
)

const Closed = ({ closed }) => (
  <div>
    <Image sizes={closed} />
  </div>
)

export default class Door extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: false, button1: false, button2: false }
  }

  render() {
    return (
      <ComponentWrapper className="">
        <div className="button-container">
          <div
            className={
              this.state.button1 == true ? 'active door-button' : 'door-button'
            }
            onMouseEnter={() => this.setState({ isOpen: true, button1: true })}
            onMouseLeave={() =>
              this.setState({ isOpen: false, button1: false })
            }
          >
            {this.state.isOpen == true && this.state.button1 == true ? (
              <PlaqueButton text="about" link="/about" image={PlaqueActive} />
            ) : (
              <PlaqueButton text="about" link="/about" image={PlaqueInactive} />
            )}
          </div>
        </div>
        <DoorAnimation
          className="image-container"
          animate={this.state.isOpen}
        />
        {/* <div className="image-container"> */}
        {/*   {this.state.isOpen == true ? ( */}
        {/*     <Open open={this.props.open} /> */}
        {/*   ) : ( */}
        {/*     <Closed closed={this.props.closed} /> */}
        {/*   )} */}
        {/* </div> */}
        <div className="button-container">
          <div
            className={
              this.state.button2 == true ? 'active door-button' : 'door-button'
            }
            number={1}
            onMouseEnter={() => this.setState({ isOpen: true, button2: true })}
            onMouseLeave={() =>
              this.setState({ isOpen: false, button2: false })
            }
          >
            {this.state.isOpen == true && this.state.button2 == true ? (
              <PlaqueButton
                text="contact"
                link="/contact"
                image={PlaqueActive}
              />
            ) : (
              <PlaqueButton
                text="contact"
                link="/contact"
                image={PlaqueInactive}
              />
            )}
          </div>
        </div>
      </ComponentWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/door.js